import { styled } from "@mui/material"
import Tooltip from "@mui/material/Tooltip"

type ControlProps = {
  icon?: React.ReactElement
  title?: string
  children: React.ReactNode
}

export function Control({ icon, title, children }: ControlProps) {
  return (
    <ControlDiv>
      {icon && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: "2px 4px",
            background: "#eee",
            borderRadius: "4px 0 0 4px",
          }}
        >
          <Tooltip title={title}>{icon}</Tooltip>
        </div>
      )}
      <div
        style={{
          display: "flex",
          flex: 1,
          alignItems: "center",
          //justifyContent: "center",
          padding: "2px 4px",
        }}
      >
        {children}
      </div>
    </ControlDiv>
  )
}

const ControlDiv = styled("div")({
  border: "0.5px solid #ccc",
  borderRadius: 4,
  display: "flex",
  alignItems: "stretch",
  flex: 1,
})
